import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { MatchHeader } from "../../MatchHeader";
import { HeadToHeadPoints } from "../../HeadToHead";
import { h2hCurrentUser, h2hOpponentUser } from "../../../Common/utils/league";
import { getBooster } from "../../../Common/utils/booster";
import { getPath, getTranslations } from "../../../Common/utils";
import { ErrorMessage } from "../../Error/message";

const Head2HeadPreviousRaceScore = ({
  race,
  handleSeasonSoFarRaceweekClick,
  handleTabClick,
}) => {
  const fixtureCircuitConfigState = useSelector(
    (state) => state.fixtureCircuitConfig
  );
  const fixtures = fixtureCircuitConfigState?.data?.fixtures;
  const leagueState = useSelector((state) => state.league);
  const translationState = useSelector((state) => state.translation);
  const commonConfigState = useSelector((state) => state.commonConfig);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <button
      className="si-battle__head si-battle__head--seasonSoFar"
      onClick={() => {
        handleSeasonSoFarRaceweekClick(race?.GamedayId);
        handleTabClick(1);
      }}
    >
      <div className="si-battle__matchHeader">
        <MatchHeader
          MatchHeaderConfig={{
            MatchHeaderRHS: true,
            MatchFixtureInfo: false,
            MatchHeaderExtra: false,
            isPreviousRaceCard: true,
          }}
          fixture={fixtures?.find(
            (fixture) => fixture?.GamedayId === race?.GamedayId
          )}
          tagName="h2"
        />
      </div>
      <HeadToHeadPoints
        user={h2hCurrentUser(leagueState?.h2hSingleRaceResultData)}
        opponent={h2hOpponentUser(leagueState?.h2hSingleRaceResultData)}
        userBooster={getBooster(
          commonConfigState?.data?.boosters,
          h2hCurrentUser(race?.raceWeekDetailsHth)?.boosterId
        )}
        opponentBooster={getBooster(
          commonConfigState?.data?.boosters,
          h2hOpponentUser(race?.raceWeekDetailsHth)?.boosterId
        )}
        userPoints={h2hCurrentUser(race?.raceWeekDetailsHth)?.currentPoint}
        opponentPoints={h2hOpponentUser(race?.raceWeekDetailsHth)?.currentPoint}
        isUserWin={
          h2hCurrentUser(race?.raceWeekDetailsHth)?.battleResult === "W"
        }
        isOpponentWin={
          h2hOpponentUser(race?.raceWeekDetailsHth)?.battleResult === "W"
        }
        handleUserClick={() => {
          navigate(
            getPath(translationState, "detailedOppTeam", {
              gameDayId: race?.GamedayId,
              phaseId: 1,
              teamNo: h2hCurrentUser(race?.raceWeekDetailsHth)?.teamNo,
            }),
            {
              state: {
                guid: h2hCurrentUser(race?.raceWeekDetailsHth)?.userguid,
                fromRoute: location?.pathname + "?st=2",
                raceWeeks: leagueState?.selectedLeague?.raceweek,
              },
            }
          );
        }}
        handleOpponentClick={() => {
          navigate(
            getPath(translationState, "detailedOppTeam", {
              gameDayId: race?.GamedayId,
              phaseId: 1,
              teamNo: h2hOpponentUser(race?.raceWeekDetailsHth)?.teamNo,
            }),
            {
              state: {
                guid: h2hOpponentUser(race?.raceWeekDetailsHth)?.userguid,
                fromRoute: location?.pathname + "?st=2",
                raceWeeks: leagueState?.selectedLeague?.raceweek,
              },
            }
          );
        }}
      />
      {h2hCurrentUser(race?.raceWeekDetailsHth)?.battleResult === "D" && (
        <ErrorMessage
          customCls={"si-errMsg--default"}
          text={getTranslations("league_hth_season_so_far_draw", "Draw")}
          iconClassName={false}
        />
      )}
    </button>
  );
};

export default Head2HeadPreviousRaceScore;
